// Updated by Vanguard: 2026-01-02T23:25:06.198Z
// Material icon fonts: load only the glyphs used on the page.
// The full variable Material Symbols fonts weigh ~4 MB each. Google Fonts can serve a
// subset with `icon_names=`, so we collect the ligature names present in the DOM per
// family and request just those (a few KB). New icons inserted later (cart drawer
// re-render, quick add, etc.) trigger a new request with the union of names.
// If a subset request fails (e.g. unknown icon name), the full family is loaded instead.
(function() {
  'use strict';

  var SYMBOL_AXES = ':opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
  var FAMILIES = {
    'material-symbols-outlined': 'Material+Symbols+Outlined' + SYMBOL_AXES,
    'material-symbols-rounded': 'Material+Symbols+Rounded' + SYMBOL_AXES,
    'material-symbols-sharp': 'Material+Symbols+Sharp' + SYMBOL_AXES,
    'material-icons': 'Material+Icons',
    'material-icons-outlined': 'Material+Icons+Outlined',
    'material-icons-round': 'Material+Icons+Round',
    'material-icons-sharp': 'Material+Icons+Sharp',
    'material-icons-two-tone': 'Material+Icons+Two+Tone'
  };
  // Elements that use a Material font through their own CSS instead of the family class.
  var EXTRA = { 'itg-btn-icon-material': 'material-symbols-outlined' };

  var SELECTOR = Object.keys(FAMILIES).concat(Object.keys(EXTRA)).map(function(c) { return '.' + c; }).join(',');
  var NAME_RE = /^[a-z0-9_]+$/;
  var used = {};      // family class -> { name: true }
  var covered = {};   // family class -> { name: true } glyphs in the last requested font ('*' = full font)

  // Base subset already requested from <head> (see layout/theme.liquid #mi-base).
  var base = document.getElementById('mi-base');
  if (base) {
    var baseFam = base.getAttribute('data-family');
    covered[baseFam] = {};
    base.getAttribute('data-icons').split(',').forEach(function(n) { covered[baseFam][n] = true; });
  }

  function familyOf(el) {
    var cl = el.classList;
    for (var k in FAMILIES) if (cl.contains(k)) return k;
    for (var e in EXTRA) if (cl.contains(e)) return EXTRA[e];
    return null;
  }

  function collect(root) {
    var els = [];
    if (root.nodeType !== 1) return;
    if (root.matches && root.matches(SELECTOR)) els.push(root);
    var found = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < found.length; i++) els.push(found[i]);
    els.forEach(function(el) {
      var fam = familyOf(el);
      var name = (el.textContent || '').trim();
      if (!fam || !NAME_RE.test(name)) return;
      (used[fam] = used[fam] || {})[name] = true;
    });
  }

  function addStylesheet(href, onerror) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'print'; // non render-blocking, switched to all once loaded
    link.onload = function() { this.media = 'all'; this.onload = null; };
    if (onerror) link.onerror = onerror;
    document.head.appendChild(link);
  }

  function flush() {
    Object.keys(used).forEach(function(fam) {
      if (covered[fam] === '*') return;
      var have = covered[fam] || {};
      var missing = Object.keys(used[fam]).filter(function(n) { return !have[n]; });
      if (!missing.length) return;
      // A later @font-face for the same family replaces the earlier one, so request the union.
      var all = {};
      Object.keys(have).concat(Object.keys(used[fam])).forEach(function(n) { all[n] = true; });
      covered[fam] = all;
      var url = 'https://fonts.googleapis.com/css2?family=' + FAMILIES[fam];
      addStylesheet(url + '&icon_names=' + Object.keys(all).sort().join(',') + '&display=block', function() {
        if (covered[fam] === '*') return;
        covered[fam] = '*';
        addStylesheet(url + '&display=block');
      });
    });
  }

  collect(document.documentElement);
  flush();

  if ('MutationObserver' in window) {
    var pending = [];
    var timer = null;
    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          // An icon's ligature text changed in place (e.g. textContent = 'close').
          if (node.nodeType === 3) node = node.parentElement;
          if (node && node.nodeType === 1) pending.push(node);
        }
      }
      if (!pending.length || timer) return;
      timer = setTimeout(function() {
        timer = null;
        var nodes = pending; pending = [];
        nodes.forEach(collect);
        flush();
      }, 100);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
